module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-photo"
  }, [(_vm.imageUrl) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.imageAlt
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "h9 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a609e394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story__CoverPhoto.vue
// module id = 395
// module chunks = 1